let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fZGiQ")).then(() => parcelRequire('arWFW'));